<ts-dialog title="Map Account" (closeDialog)="dialogRef.close()">
  <div class="w-full flex flex-col gap-4" ts-dialog-body>
    <form class="flex flex-col gap-4" [formGroup]="accountMappingForm">
      <div class="flex flex-row items-center justify-between">
        <p class="required">Account</p>
        <ts-select
          [formControl]="accountMappingFormControls.regularAccountId"
          [items]="regularAccounts$ | async"
          itemKey="value"
          itemLabel="label"
          class="w-1/2"
          [hasGroups]="false"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Select account',
            searchPlaceholder: 'Search accounts...',
            size: 'full',
          }"
        ></ts-select>
      </div>

      <div class="flex flex-row items-center justify-between">
        <p class="required">Category</p>
        <ts-select
          [formControl]="accountMappingFormControls.categoryAccountId"
          [items]="categoryOptions$ | async"
          itemKey="value"
          itemLabel="label"
          class="w-1/2"
          [hasGroups]="false"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Select category',
            searchPlaceholder: 'Search categories...',
            size: 'full',
          }"
        ></ts-select>
      </div>
    </form>
  </div>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="dialogRef.close()">Cancel</ts-button>
    <ts-button variant="primary" [disabled]="!isSubmitable" (click)="submitForm()">Save</ts-button>
  </div>
</ts-dialog>
